import * as React from 'react';
import classnames from 'classnames';
import compose from 'lodash/flowRight';
import withProviders from '../_utils/withProviders';
import withSidebarState from '../_utils/withSidebarState';

var Theme = function Theme(_ref) {
  var children = _ref.children,
      isSidebarOpened = _ref.isSidebarOpened;

  var _className = classnames('Theme', {
    'Theme--with-sidebar': isSidebarOpened
  });

  return React.createElement("div", {
    className: _className
  }, children);
};

Theme.defaultProps = {
  children: undefined
};

var _withProviders = function _withProviders(Component) {
  return withProviders(Component);
};

var _withSidebarState = function _withSidebarState(Component) {
  return withSidebarState(Component);
};

var enhance = compose(_withProviders, _withSidebarState);
export default enhance(Theme);